/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MrfiktivCreateRepairEstimateRequestDtoGen,
  MrfiktivCreateRequestStatusHistoryElementDtoGen,
  MrfiktivPageViewModelGen,
  MrfiktivRepairEstimateRequestControllerFindOneWithAccessSignatureParamsGen,
  MrfiktivRepairEstimateRequestControllerGetParamsGen,
  MrfiktivRepairEstimateRequestControllerRespondAcceptParamsGen,
  MrfiktivRepairEstimateRequestControllerRespondRejectParamsGen,
  MrfiktivRepairEstimateRequestViewModelGen,
  MrfiktivUpdateRepairEstimateRequestDtoGen,
  MrfiktivUpdateRepairEstimateRequestResponseAcceptDtoGen
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class RepairEstimateRequest<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags repair-estimate-request
   * @name RepairEstimateRequestControllerCreate
   * @summary (RepairEstimateRequest - CREATE) Create an RepairEstimateRequest
   * @request POST:/partner/{partnerId}/repair-estimate-request
   * @secure
   * @response `201` `MrfiktivRepairEstimateRequestViewModelGen` The created repairEstimateRequest
   */
  repairEstimateRequestControllerCreate = (
    partnerId: string,
    data: MrfiktivCreateRepairEstimateRequestDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivRepairEstimateRequestViewModelGen, any>({
      path: `/partner/${partnerId}/repair-estimate-request`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags repair-estimate-request
   * @name RepairEstimateRequestControllerGet
   * @summary (RepairEstimateRequest - READ) Get all repairEstimateRequests
   * @request GET:/partner/{partnerId}/repair-estimate-request
   * @secure
   * @response `200` `(MrfiktivPageViewModelGen & { data?: (MrfiktivRepairEstimateRequestViewModelGen)[] })`
   */
  repairEstimateRequestControllerGet = (
    { partnerId, ...query }: MrfiktivRepairEstimateRequestControllerGetParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivPageViewModelGen & { data?: MrfiktivRepairEstimateRequestViewModelGen[] }, any>({
      path: `/partner/${partnerId}/repair-estimate-request`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags repair-estimate-request
   * @name RepairEstimateRequestControllerGetOne
   * @summary (RepairEstimateRequest - READ) Get an repairEstimateRequest
   * @request GET:/partner/{partnerId}/repair-estimate-request/{repairEstimateRequestId}
   * @secure
   * @response `200` `MrfiktivRepairEstimateRequestViewModelGen` The repairEstimateRequest
   */
  repairEstimateRequestControllerGetOne = (
    partnerId: string,
    repairEstimateRequestId: string,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivRepairEstimateRequestViewModelGen, any>({
      path: `/partner/${partnerId}/repair-estimate-request/${repairEstimateRequestId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags repair-estimate-request
   * @name RepairEstimateRequestControllerUpdate
   * @summary (RepairEstimateRequest - UPDATE) Updates an repairEstimateRequest
   * @request PATCH:/partner/{partnerId}/repair-estimate-request/{repairEstimateRequestId}
   * @secure
   * @response `201` `MrfiktivRepairEstimateRequestViewModelGen` The updated repairEstimateRequest
   */
  repairEstimateRequestControllerUpdate = (
    partnerId: string,
    repairEstimateRequestId: string,
    data: MrfiktivUpdateRepairEstimateRequestDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivRepairEstimateRequestViewModelGen, any>({
      path: `/partner/${partnerId}/repair-estimate-request/${repairEstimateRequestId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags repair-estimate-request
   * @name RepairEstimateRequestControllerDelete
   * @summary (RepairEstimateRequest - DELETE) Deletes an repairEstimateRequest
   * @request DELETE:/partner/{partnerId}/repair-estimate-request/{repairEstimateRequestId}
   * @secure
   * @response `200` `MrfiktivRepairEstimateRequestViewModelGen` The deleted repairEstimateRequest
   */
  repairEstimateRequestControllerDelete = (
    partnerId: string,
    repairEstimateRequestId: string,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivRepairEstimateRequestViewModelGen, any>({
      path: `/partner/${partnerId}/repair-estimate-request/${repairEstimateRequestId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags repair-estimate-request
   * @name RepairEstimateRequestControllerFindOneWithAccessSignature
   * @summary (SCT) Get an repairEstimateRequest
   * @request GET:/partner/{partnerId}/repair-estimate-request/{repairEstimateRequestId}/access
   * @secure
   * @response `200` `MrfiktivRepairEstimateRequestViewModelGen` The found record
   * @response `400` `void` Bad Request.
   * @response `403` `void` Forbidden.
   * @response `404` `void` Report not found.
   */
  repairEstimateRequestControllerFindOneWithAccessSignature = (
    {
      partnerId,
      repairEstimateRequestId,
      ...query
    }: MrfiktivRepairEstimateRequestControllerFindOneWithAccessSignatureParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivRepairEstimateRequestViewModelGen, void>({
      path: `/partner/${partnerId}/repair-estimate-request/${repairEstimateRequestId}/access`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags repair-estimate-request
   * @name RepairEstimateRequestControllerRespondAccept
   * @summary (sct) Accepts a repair estimate request
   * @request PATCH:/partner/{partnerId}/repair-estimate-request/{repairEstimateRequestId}/response/accept
   * @secure
   * @response `201` `MrfiktivRepairEstimateRequestViewModelGen` The updated repairEstimateRequest
   */
  repairEstimateRequestControllerRespondAccept = (
    { partnerId, repairEstimateRequestId, ...query }: MrfiktivRepairEstimateRequestControllerRespondAcceptParamsGen,
    data: MrfiktivUpdateRepairEstimateRequestResponseAcceptDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivRepairEstimateRequestViewModelGen, any>({
      path: `/partner/${partnerId}/repair-estimate-request/${repairEstimateRequestId}/response/accept`,
      method: "PATCH",
      query: query,
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags repair-estimate-request
   * @name RepairEstimateRequestControllerRespondReject
   * @summary (sct) Updates an repairEstimateRequest
   * @request PATCH:/partner/{partnerId}/repair-estimate-request/{repairEstimateRequestId}/response/reject
   * @secure
   * @response `201` `MrfiktivRepairEstimateRequestViewModelGen` The updated repairEstimateRequest
   */
  repairEstimateRequestControllerRespondReject = (
    { partnerId, repairEstimateRequestId, ...query }: MrfiktivRepairEstimateRequestControllerRespondRejectParamsGen,
    data: MrfiktivCreateRequestStatusHistoryElementDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivRepairEstimateRequestViewModelGen, any>({
      path: `/partner/${partnerId}/repair-estimate-request/${repairEstimateRequestId}/response/reject`,
      method: "PATCH",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
}
